import { useEffect, useRef, useState } from 'react';

export default function useObserver({
  root = null,
  rootMargin,
  threshold = 0,
  isUnsubscribe = false
}: ObserverOptions) {
  const [entry, updateEntry] = useState(null);
  const [node, setNode] = useState(null);
  const observer = useRef(null);

  useEffect(() => {
    if (observer.current) observer.current.disconnect();
    if (!isUnsubscribe && window && window.IntersectionObserver) {
      observer.current = new window.IntersectionObserver(
        ([entryElem]) => updateEntry(entryElem),
        {
          root,
          rootMargin,
          threshold
        }
      );
      if (node) observer.current.observe(node);
    }

    return () => observer && observer.current && observer.current.disconnect();
  }, [node, root, rootMargin, threshold, isUnsubscribe]);

  return [setNode, entry];
}
